export const PROVINCES = [
  { label: 'A Coruña', value: 'A Coruña' },
  { label: 'Álava', value: 'Álava' },
  { label: 'Albacete', value: 'Albacete' },
  { label: 'Alicante', value: 'Alicante' },
  { label: 'Almería', value: 'Almería' },
  { label: 'Asturias', value: 'Asturias' },
  { label: 'Ávila', value: 'Ávila' },
  { label: 'Badajoz', value: 'Badajoz' },
  { label: 'Baleares', value: 'Baleares' },
  { label: 'Barcelona', value: 'Barcelona' },
  { label: 'Burgos', value: 'Burgos' },
  { label: 'Cáceres', value: 'Cáceres' },
  { label: 'Cádiz', value: 'Cádiz' },
  { label: 'Cantabria', value: 'Cantabria' },
  { label: 'Castellón', value: 'Castellón' },
  { label: 'Ceuta', value: 'Ceuta' },
  { label: 'Ciudad Real', value: 'Ciudad Real' },
  { label: 'Córdoba', value: 'Córdoba' },
  { label: 'Cuenca', value: 'Cuenca' },
  { label: 'Girona', value: 'Girona' },
  { label: 'Granada', value: 'Granada' },
  { label: 'Guadalajara', value: 'Guadalajara' },
  { label: 'Gipuzkoa', value: 'Gipuzkoa' },
  { label: 'Huelva', value: 'Huelva' },
  { label: 'Huesca', value: 'Huesca' },
  { label: 'Jaén', value: 'Jaén' },
  { label: 'La Rioja', value: 'La Rioja' },
  { label: 'Las Palmas', value: 'Las Palmas' },
  { label: 'León', value: 'León' },
  { label: 'Lérida', value: 'Lérida' },
  { label: 'Lugo', value: 'Lugo' },
  { label: 'Madrid', value: 'Madrid' },
  { label: 'Málaga', value: 'Málaga' },
  { label: 'Melilla', value: 'Melilla' },
  { label: 'Murcia', value: 'Murcia' },
  { label: 'Navarra', value: 'Navarra' },
  { label: 'Ourense', value: 'Ourense' },
  { label: 'Palencia', value: 'Palencia' },
  { label: 'Pontevedra', value: 'Pontevedra' },
  { label: 'Salamanca', value: 'Salamanca' },
  { label: 'Santa Cruz de Tenerife', value: 'Santa Cruz de Tenerife' },
  { label: 'Segovia', value: 'Segovia' },
  { label: 'Sevilla', value: 'Sevilla' },
  { label: 'Soria', value: 'Soria' },
  { label: 'Tarragona', value: 'Tarragona' },
  { label: 'Teruel', value: 'Teruel' },
  { label: 'Toledo', value: 'Toledo' },
  { label: 'Valencia', value: 'Valencia' },
  { label: 'Valladolid', value: 'Valladolid' },
  { label: 'Vizcaya', value: 'Vizcaya' },
  { label: 'Zamora', value: 'Zamora' },
  { label: 'Zaragoza', value: 'Zaragoza' },
];
